/**
 * Utility to calculate date ranges for compensation and payroll voucher filters.
 */

export const DATE_PRESET_OPTIONS = [
  { value: 'All', label: 'All Dates' },
  { value: 'This Month', label: 'This Month' },
  { value: 'Last Month', label: 'Last Month' },
  { value: 'This Quarter', label: 'This Quarter' },
  { value: 'This Financial Year', label: 'This Financial Year' },
  { value: 'Custom', label: 'Custom Date' },
];

function padZero(num) {
  return String(num).padStart(2, '0');
}

function formatDateISO(d) {
  return `${d.getFullYear()}-${padZero(d.getMonth() + 1)}-${padZero(d.getDate())}`;
}

export function getDatePresetRange(presetKey) {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // 0-indexed

  switch (presetKey) {
    case 'This Month': {
      const from = new Date(currentYear, currentMonth, 1);
      const to = new Date(currentYear, currentMonth + 1, 0);
      return { fromDate: formatDateISO(from), toDate: formatDateISO(to) };
    }
    case 'Last Month': {
      const from = new Date(currentYear, currentMonth - 1, 1);
      const to = new Date(currentYear, currentMonth, 0);
      return { fromDate: formatDateISO(from), toDate: formatDateISO(to) };
    }
    case 'This Quarter': {
      const quarterIndex = Math.floor(currentMonth / 3);
      const from = new Date(currentYear, quarterIndex * 3, 1);
      const to = new Date(currentYear, (quarterIndex + 1) * 3, 0);
      return { fromDate: formatDateISO(from), toDate: formatDateISO(to) };
    }
    case 'This Financial Year': {
      // Indian Financial Year: April 1 to March 31
      let startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
      const from = new Date(startYear, 3, 1); // April 1st
      const to = new Date(startYear + 1, 2, 31); // March 31st
      return { fromDate: formatDateISO(from), toDate: formatDateISO(to) };
    }
    case 'All':
    default:
      return { fromDate: '', toDate: '' };
  }
}
